import { render, staticRenderFns } from "./MarathonPickup.vue?vue&type=template&id=58482042&"
import script from "./MarathonPickup.vue?vue&type=script&lang=js&"
export * from "./MarathonPickup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports